<template>
  <el-dialog
    id="department-dialog-component"
    :close-on-click-modal="false"
    :title="departmentDialogTitle"
    :visible.sync="departmentDialog"
    :before-close="closeDepartmentDialog"
    width="800px"
  >
    <div class="department-content">
      <div class="select-container">
        <div class="department-list">
          <AllTreeCheckout
            :refStr="refStr"
            :companyList="departmentList"
            :departmentId="departmentId"
            :selectData="selectData"
            @selectTreeNodeList="selectDepartmentHeadTreeNodeList"
          />
        </div>
      </div>
      <div class="border"></div>
      <div class="selected-container">
        <p class="label">已选：</p>
        <div class="selected-content">
          <ul class="selected-list">
            <li
              class="selected-item"
              v-for="(value, index) in selectData"
              :key="index"
            >
              <span class="selected-item-name">
                <img :src="second" class="second">
                {{ value.departmentName }}
              </span>
              <span class="remove" @click="removeSelectData(index)">移除</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDepartmentDialog">取 消</el-button>
      <el-button type="primary" @click="submitDepartmentDialog"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import AllTreeCheckout from "@/components/tree/all-tree-checkout.vue";
import { mapChildChildrenNoDisable } from "@/common/js/utils.js";
import { getTeamId } from "common/js/storage";
import Staff from "@/models/staff.js";
export default {
  props: {
    refStr: {
      type: String,
      default: "tree",
    },
    departmentDialogTitle: {
      type: String,
      default: "请选择部门",
    },
    departmentDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AllTreeCheckout
  },
  data() {
    return {
      second: require('../assets/tree/second.png'),
      searchDepartment: "",
      selectData: [],
      departmentList: [],
      departmentId: 0,
    };
  },
  created() {
    this.getDepartmentList()
  },
  mounted () {
    this.$bus.on('initSelectAllList', v => {
      let arr = []
      v.map(i => {
        let obj = {}
        obj.id = i.id
        obj.id2 = i.id
        obj.departmentName = i.name
        obj.zzdCode = i.zzdCode
        arr.push(obj)
      })
      this.selectData = arr
      this.$bus.emit('allTreeCheckedLighDate', arr)
    })
  },
  methods: {
    /* 获取部门与成员数据 */
    getDepartmentList() {
      let searchDepartment = ''
      let id = this.departmentId != 0? this.departmentId: getTeamId()
      Staff.getDepartmentPeopleList(id, searchDepartment).then(res => {
        if (res.success) {
          let arr = mapChildChildrenNoDisable(res.result);
          this.departmentList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 移除 */
    removeSelectData(index) {
      this.selectData.splice(index, 1);
      this.$bus.emit('allTreeCheckedDel', this.selectData)
    },

    /* 关闭弹窗 */
    closeDepartmentDialog() {
      this.searchDepartment = "";
      this.selectData = [];
      this.$bus.emit('allTreeCheckedLighDate', [])
      this.$emit("allOPenOrCloseDepartmentDialog", false);
    },

    /* 确定弹窗 */
    submitDepartmentDialog() {
      this.$emit("allSubmitSelectData", this.selectData);
      this.$bus.emit('allTreeCheckedLighDate', [])
      this.$emit("allOPenOrCloseDepartmentDialog", false);
    },

    selectDepartmentHeadTreeNodeList(v) {
      this.selectData = v
    }
  },
};
</script>
<style lang='scss'>
#department-dialog-component {
  .el-dialog__body {
    position: relative;
  }
  .department-content {
    margin: 16px 20px;
    border: 1px solid $bg-ShallowLightSnow;
    display: flex;
    justify-content: space-between;
    overflow-y: auto;
    overflow-x: hidden;
    height: 350px;
    .border {
      position: absolute;
      top: 0px;
      left: 50%;
      height: 350px;
      transform: translateX(-50%);
      width: 1px;
      background: $bg-ShallowLightSnow;
    }
    .select-container {
      width: 49%;
      .department-list {
        padding: 12px;
        box-sizing: border-box;
      }
    }
    .selected-container {
      width: 49%;
      padding: 12px;
      box-sizing: border-box;
      .label {
        text-align: left;
        height: 40px;
        line-height: 40px;
        font-size: $fs-medium-s;
      }
      .selected-content {
        padding: 12px;
        box-sizing: border-box;
        .selected-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: $fs-small-l;
          color: $color-grey;
          .second {
            margin-right: 19px;
          }
          .selected-item-name {
            height: 14px;
            line-height: 14px;
          }
          .remove {
            color: #ed6767;
            cursor: pointer;
          }
        }
      }
    }
  }
  .department-dialog-footer {
    display: flex;
    justify-content: center;
    padding-top: 16px;
  }
}
</style>